export const MEDICARE_SEARCH = {
  ZIP_CODE: {
    search_type: 'zip_code',
  },
  PROVIDER: {
    search_type: 'provider',
  },
  PLAN: {
    search_type: 'provider_plan',
  },
  DRUG: {
    search_type: 'drug',
  },
};
